import Head from 'next/head';
import { useTranslationResponse } from '@isomorphic/hooks/use-translation-response';

export const AppHead = () => (
  <Head>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>{`${useTranslationResponse('SiteTitle')}`}</title>
  </Head>
);
